/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-04-18 22:23:17
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-06-28 13:42:30
 */
const h5 = [
    {
        path: "/wechatHome",
        name: "wechatHome",
        component: () => import("../views/staticH5/wechatHome.vue")
    },
    {
        path: "/customerService/bh",
        name: "customerService",
        component: () => import("../views/staticH5/customerServiceTwo.vue")
    },
    {
        path: "/doctor/reg/:id/:channel/:code",
        name: "doctorReg",
        component: () => import("../views/staticH5/regDoctor.vue")
    },
    {
        path: "/diagnosis",
        name: "diagnosis",
        component: () => import("../views/staticH5/diagnosis.vue")
    },
    {
        path: "/faceRecognition/:type",
        name: "faceRecognition",
        component: () => import("../views/staticH5/faceRecognition.vue")
    }
];
export default h5;



// WEBPACK FOOTER //
// ./src/router/h5.js